var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:menu-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16667 27.75C5.72986 27.75 5.36397 27.602 5.069 27.306C4.77403 27.01 4.62603 26.6441 4.625 26.2083C4.62397 25.7726 4.77197 25.4067 5.069 25.1107C5.36603 24.8147 5.73192 24.6667 6.16667 24.6667H30.8333C31.2701 24.6667 31.6365 24.8147 31.9325 25.1107C32.2285 25.4067 32.376 25.7726 32.375 26.2083C32.374 26.6441 32.226 27.0105 31.931 27.3075C31.636 27.6046 31.2701 27.7521 30.8333 27.75H6.16667ZM6.16667 20.0417C5.72986 20.0417 5.36397 19.8937 5.069 19.5977C4.77403 19.3017 4.62603 18.9358 4.625 18.5C4.62397 18.0642 4.77197 17.6983 5.069 17.4023C5.36603 17.1063 5.73192 16.9583 6.16667 16.9583H30.8333C31.2701 16.9583 31.6365 17.1063 31.9325 17.4023C32.2285 17.6983 32.376 18.0642 32.375 18.5C32.374 18.9358 32.226 19.3022 31.931 19.5992C31.636 19.8962 31.2701 20.0437 30.8333 20.0417H6.16667ZM6.16667 12.3333C5.72986 12.3333 5.36397 12.1853 5.069 11.8893C4.77403 11.5933 4.62603 11.2274 4.625 10.7917C4.62397 10.3559 4.77197 9.99 5.069 9.694C5.36603 9.398 5.73192 9.25 6.16667 9.25H30.8333C31.2701 9.25 31.6365 9.398 31.9325 9.694C32.2285 9.99 32.376 10.3559 32.375 10.7917C32.374 11.2274 32.226 11.5938 31.931 11.8909C31.636 12.1879 31.2701 12.3354 30.8333 12.3333H6.16667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.a770b179529499e494abfd3add7cc65d.svg";
export { ForwardRef as ReactComponent };